import { defineMessages } from 'react-intl'

const scope = `procurify.platform.banking.presenter.GetFinancialAccountBankingDetailsPresenter`

export default defineMessages({
  buttonText: {
    id: `${scope}.buttonText`,
    defaultMessage: 'Add funds',
  },
  fetchingDetailsToastError: {
    id: `${scope}.fetchingDetailsToastError`,
    defaultMessage: 'Error fetching account details',
  },
})
